<template>
    <div :class="[state, 'item']">
        <div class="grid-x title" @click="$emit('toggle')">
            <div class="cell shrink">
                <div class="state">
                    <img src="../assets/baseline-check-24px.svg" alt="" v-if="state==='done'">
                </div>
            </div>
            <div class="cell auto">
                <h2>{{ title }}</h2>
            </div>
            <div class="cell shrink toggle">
                <img src="../assets/baseline-keyboard_arrow_down-24px.svg" alt="" v-if="!opened">
                <img src="../assets/baseline-keyboard_arrow_up-24px.svg" alt="" v-else>
            </div>
        </div>
        <div class="grid-x" v-if="body.length && opened">
            <div class="cell body" v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String
        },
        state: {
            type: String
        },
        body: {
            type: String,
            default: ''
        },
        opened: {
            type: Boolean,
            default: true
        }
    }
}
</script>